module.exports = __webpack_public_path__ + "static/media/Dmitriy_circle.4b0c64f4.png";